export default __webpack_public_path__ + "static/media/close-white.f7ace150.svg";